module.exports = __webpack_public_path__ + "media/images/icons/payment_first_step-8e57928b302d12bb7f19958781c764b8.svg";